import React from 'react';
import cookieDough from 'cookie-dough';
import Grid from '../Grid';
import { HeroStyled, TextHeader, Headline, Tag, ImageBlock, Button } from './styled';

const cookie = cookieDough();
const AB_TEST = 'cta-features-pgs';

class Hero extends React.Component {
  componentDidMount() {
    const abExperiments = this.getExperiments();
    if (abExperiments && abExperiments[AB_TEST]) {
      window.metricsLib.track(`ab:viewed-${AB_TEST}`, {
        experiment_id: AB_TEST,
        variation_id: abExperiments[AB_TEST],
      });
    }
  }

  getExperiments() {
    return this.props.abExperiments || JSON.parse(cookie.get('ajs_ab.traits'));
  }

  render() {
    const abExperiments = this.getExperiments();
    return (
      <HeroStyled>
        <Grid>
          <TextHeader>
            <Tag>
              <img
                src="https://cdn.auth0.com/website/universal-login/univ-login-hero-icon.svg"
                alt="Universal Login"
              />
              <h2>UNIVERSAL LOGIN</h2>
            </Tag>
            <Headline>
              Secure login infrastructure <br />to authenticate users <br /> to your apps
            </Headline>
            {abExperiments && abExperiments[AB_TEST] === 'variant' ?
            (
              <Button href="/get-started" target="_blank" className="btn btn-success btn-lg">
                Get Started
              </Button>
            ) : (
              <div>
                <Button href="javascript:signup()" className="btn btn-success btn-lg">
                  Get Started
                </Button>
                <Button
                  href="https://auth0.com/docs/hosted-pages/login"
                  rel="external"
                  className="btn btn-transparent btn-lg white"
                >
                  Read The Docs
                </Button>
              </div>
            )}
          </TextHeader>
          <ImageBlock>
            <img src="https://cdn.auth0.com/website/universal-login/exp_univ_login_hero.svg" alt="" />
          </ImageBlock>
        </Grid>
      </HeroStyled>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/Hero/Hero.js